import type { JSX, ReactNode } from 'react';

import { usePermissions } from '@/hooks/usePermissions';
import type { PolicyName } from '@/permissions/types';

type Props = {
  policy: PolicyName;
  resource?: unknown;
  children: ReactNode;
  fallback?: ReactNode;
};

export function CanAccess({ policy, resource, children, fallback = null }: Props): JSX.Element {
  const { isAllowed } = usePermissions();
  return isAllowed(policy, resource) ? <>{children}</> : <>{fallback}</>;
}
